// export default function Navbar({ page, go }) {
//   return (
//     <nav style={{ position: 'sticky', top: 0, zIndex: 100, background: 'white', borderBottom: '1px solid var(--border)', padding: '0 2rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: 68 }}>
//       <div onClick={() => go('home')} style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 10 }}>
//         <div style={{ width: 38, height: 38, borderRadius: '50%', background: 'var(--teal)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontFamily: "'DM Serif Display',serif", fontSize: 16, flexShrink: 0 }}>T</div>
//         <span style={{ fontFamily: "'DM Serif Display',serif", fontSize: 20, color: 'var(--teal-deeper)' }}>
//           Tiny<span style={{ color: 'var(--coral)' }}>trust</span>
//         </span>
//       </div>

//       <div style={{ display: 'flex', alignItems: 'center', gap: 28 }}>
//         {[['home','Home'],['nannies','Find a nanny'],['vetting','Our vetting'],['about','About'],['pricing','Pricing'],['consult','Contact']].map(([p,l]) => (
//           <span key={p} onClick={() => go(p)} style={{ fontSize: 14, fontWeight: 500, color: page===p ? 'var(--teal)' : 'var(--text-mid)', cursor: 'pointer', transition: 'color .2s', whiteSpace: 'nowrap' }}
//             onMouseEnter={e => e.target.style.color='var(--teal)'}
//             onMouseLeave={e => e.target.style.color = page===p ? 'var(--teal)' : 'var(--text-mid)'}
//           >{l}</span>
//         ))}
//         <a href="tel:2045103869" style={{ fontSize: 14, color: 'var(--text-mid)', textDecoration: 'none', fontWeight: 500, whiteSpace: 'nowrap' }}>📞 204-510-3869</a>
//         <button className="btn-coral" style={{ padding: '10px 20px', fontSize: 13, borderRadius: 8, whiteSpace: 'nowrap' }} onClick={() => go('consult')}>Book a consult</button>
//       </div>
//     </nav>
//   );
// }
import { useState } from 'react';

export default function Navbar({ page, go }) {
  const [menuOpen, setMenuOpen] = useState(false);

  const navGo = (p) => { go(p); setMenuOpen(false); };

  return (
    <nav style={{ position:'sticky', top:0, zIndex:100, background:'white', borderBottom:'1px solid var(--border)' }}>
      <div style={{ padding:'0 1.5rem', display:'flex', alignItems:'center', justifyContent:'space-between', height:72 }}>
        
        {/* LOGO */}
        {/* LOGO */}
<div onClick={() => navGo('home')} style={{ cursor:'pointer', display:'flex', alignItems:'center' }}>
  <img src="/Tinnytrust.jpg" alt="Tinytrust Services" style={{ height:52, width:'auto', objectFit:'contain' }} />
</div>

        {/* DESKTOP NAV */}
        <div style={{ display:'flex', alignItems:'center', gap:24, '@media(max-width:768px)':{display:'none'} }} className="desktop-nav">
          {[['home','How it works'],['nannies','Find a nanny'],['vetting','Our vetting'],['about','About Ebere'],['pricing','Pricing'],['consult','Contact']].map(([p,l]) => (
            <span key={p} onClick={() => navGo(p)} style={{ fontSize:14, fontWeight:500, color:page===p?'var(--teal)':'var(--text-mid)', cursor:'pointer', transition:'color .2s', whiteSpace:'nowrap' }}>{l}</span>
          ))}
          <a href="tel:2045103869" style={{ fontSize:13, color:'var(--text-mid)', textDecoration:'none', fontWeight:500 }}>📞 204-510-3869</a>
          <button className="btn-coral" style={{ padding:'9px 18px', fontSize:13, borderRadius:8 }} onClick={() => navGo('consult')}>Book a consult</button>
        </div>

        {/* MOBILE HAMBURGER */}
        <button onClick={() => setMenuOpen(!menuOpen)} className="mobile-menu-btn" style={{ display:'none', background:'none', border:'none', cursor:'pointer', padding:8, flexDirection:'column', gap:5 }}>
          <div style={{ width:24, height:2, background:'var(--teal-deeper)', borderRadius:2, transition:'all .3s', transform:menuOpen?'rotate(45deg) translate(5px,5px)':'none' }}/>
          <div style={{ width:24, height:2, background:'var(--teal-deeper)', borderRadius:2, transition:'all .3s', opacity:menuOpen?0:1 }}/>
          <div style={{ width:24, height:2, background:'var(--teal-deeper)', borderRadius:2, transition:'all .3s', transform:menuOpen?'rotate(-45deg) translate(5px,-5px)':'none' }}/>
        </button>
      </div>

      {/* MOBILE MENU */}
      {menuOpen && (
        <div style={{ background:'white', borderTop:'1px solid var(--border)', padding:'1rem 1.5rem 1.5rem' }} className="mobile-menu">
          {[['home','🏠 How it works'],['nannies','👩 Find a nanny'],['vetting','🛡️ Our vetting'],['about','❤️ About Ebere'],['pricing','💰 Pricing'],['consult','📞 Contact']].map(([p,l]) => (
            <div key={p} onClick={() => navGo(p)} style={{ padding:'14px 0', borderBottom:'1px solid var(--border)', fontSize:15, fontWeight:page===p?600:400, color:page===p?'var(--teal)':'var(--text)', cursor:'pointer' }}>{l}</div>
          ))}
          <div style={{ marginTop:16, display:'flex', flexDirection:'column', gap:10 }}>
            <a href="tel:2045103869" style={{ fontSize:14, color:'var(--teal)', textDecoration:'none', fontWeight:600, padding:'12px 0' }}>📞 204-510-3869</a>
            <button className="btn-coral" style={{ width:'100%', padding:14, fontSize:15, borderRadius:10 }} onClick={() => navGo('consult')}>Book a free consult</button>
          </div>
        </div>
      )}

      <style>{`
        @media (max-width: 768px) {
          .desktop-nav { display: none !important; }
          .mobile-menu-btn { display: flex !important; }
        }
        @media (min-width: 769px) {
          .mobile-menu { display: none !important; }
        }
      `}</style>
    </nav>
  );
}